import React from 'react'
import { Accordion, Button, Card, Modal } from 'react-bootstrap'
import { Icon } from 'react-icons-kit'
import { cross } from 'react-icons-kit/icomoon/'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"
import API from '../Components/Global_API'
import Router from '../Router';
import moment from 'moment';
import ReactCustomFlagSelect from 'react-custom-flag-select';
import "react-custom-flag-select/lib/react-custom-flag-select.min.css";
import FLAG_SELECTOR_OPTION_LIST from '../Components/FlagList'
import NoInternet from '../Components/NoInternet';

const find = (arr, obj) => {
    const res = [];
    arr.forEach(o => {
        let match = false;
        Object.keys(obj).map(i => {
            if (obj[i] === o[i]) {
                match = true;
            }
        });
        if (match) {
            res.push(o);
        }
    });
    return res;
};

const DEFAULT_AREA_CODE = FLAG_SELECTOR_OPTION_LIST[0].id;

const styles = {
    inputDiv: {
        paddingBottom: 10
    },
    inputAssessor_name: {
        border: 'solid',
        borderWidth: 1,
        borderColor: '#999',
        borderTopWidth: 0,
        listStyle: 'none',
        marginTop: 0,
        maxHeight: 150,
        overflowY: 'auto',
        paddingLeft: 0,
        backgroundColor: "#fff"
    },
    inputAssessor_nameList: {
        padding: 10,
        borderBottom: '1px solid rgba(153, 153, 153, 0.32)',
        cursor: 'pointer'
    },
    activeinputAssessor_name: {
        padding: 10,
        borderBottom: '1px solid rgba(153, 153, 153, 0.32)',
        cursor: 'pointer'
    },
    clearFilterIcon: {
        padding: 5,
        color: 'rgb(138, 141, 150)'
    },
    inputField: {
        height: 40
    }
}

// const removeEmojis = (string) => {
//     // emoji regex from the emoji-regex library
const regex = /\uD83C\uDFF4(?:\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74)\uDB40\uDC7F|\u200D\u2620\uFE0F)|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC68(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3]))|\uD83D\uDC69\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\uD83D\uDC68(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83D\uDC69\u200D[\u2695\u2696\u2708])\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC68(?:\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDB5\uDDB6\uDDD1-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDEEB\uDEEC\uDEF4-\uDEF9]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD70\uDD73-\uDD76\uDD7A\uDD7C-\uDDA2\uDDB0-\uDDB9\uDDC0-\uDDC2\uDDD0-\uDDFF])|(?:[#*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEF9]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD70\uDD73-\uDD76\uDD7A\uDD7C-\uDDA2\uDDB0-\uDDB9\uDDC0-\uDDC2\uDDD0-\uDDFF])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC69\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDDB5\uDDB6\uDDB8\uDDB9\uDDD1-\uDDDD])/g

//     return string.replace(regex, '')
//   }


export default class Edit_Assessor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            assessor_id: '',
            first_name: '',
            last_name: '',
            middle_name: '',
            search: '',
            // search_by: '',
            date_of_birth: '',
            gender: '',
            email: '',
            address: '',
            region: '',
            added_by: '',
            post_code: '',
            contact_number: '',
            region_data: [],
            assessor_data: [],
            showAssessorList: false,
            user_message: '',
            areaCode: DEFAULT_AREA_CODE,
            phone: "",
            hasPhoneError: true,
            validate: false,
            delete_assessor: false,
            date_of_birthValidation: true,
            isLoader: true,
            data_saveLoader: false
        }
        let loginUser = localStorage.getItem("loginUser")
        if (loginUser == null) {
            window.location.href = '/';
        } else {
            if (this.props.location.state) {
                this.state.assessor_id = this.props.location.state.assessor.id;
                this.state.first_name = this.props.location.state.assessor.first_name;
                this.state.middle_name = this.props.location.state.assessor.middle_name;
                this.state.last_name = this.props.location.state.assessor.last_name;
                this.state.date_of_birth = moment(this.props.location.state.assessor.date_of_birth).toDate();
                this.state.gender = this.props.location.state.assessor.gender;
                this.state.email = this.props.location.state.assessor.email;
                this.state.address = this.props.location.state.assessor.address;
                this.state.region = this.props.location.state.assessor.regions;
                this.state.added_by = this.props.location.state.assessor.added_by;
                this.state.post_code = this.props.location.state.assessor.post_code;
                let contact_number = this.props.location.state.assessor.contact.split(' ');
                this.state.contact_number = contact_number[1];
                this.state.areaCode = contact_number[0]
            }
        }
    }

    componentDidMount() {
        this.setState({ isLoader: false })
        fetch(API + 'get_all_data.php').then((response) => response.json()).then((responseJsonFromServer) => {

            if (responseJsonFromServer.result == "success") {
                this.setState({
                    region_data: responseJsonFromServer.regions_data,
                })

                let region = this.state.region_data.filter(item => {
                    return item.regions == this.state.region
                })
                this.setState({
                    region: region[0].region_id
                })

            } else {
                var x = document.getElementById("snackbar");
                x.className = "show";
                setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);
                x.innerHTML = responseJsonFromServer.msg;
            }

        }).catch((error) => {
            if (error.message == 'Failed to fetch') {
                this.setState({ networkError: true })
            }
        });
    }

    press = (e) => {
        if (e.ctrlKey || e.altKey) {

            e.preventDefault();

        } else {

            var key = e.keyCode;

            if (!((key == 8) || (key == 46) || (key >= 35 && key <= 40) || (key >= 65 && key <= 90))) {

                e.preventDefault();

            }
        }
    }

    number_press = (event) => {
        if (!(event.ctrlKey || event.altKey
            || (47 < event.keyCode && event.keyCode < 58 && event.shiftKey == false)
            || (95 < event.keyCode && event.keyCode < 106)
            || (event.keyCode == 8) || (event.keyCode == 9)
            || (event.keyCode > 34 && event.keyCode < 40)
            || (event.keyCode == 46))) {
            event.preventDefault();
        }
    }

    handleFirstname = (e) => {
        if (e.target.value.trim().length == 0) {
            document.getElementsByClassName('error_first_name')[0].innerHTML = 'First Name is required.';
            document.getElementsByClassName('error_first_name')[0].style.display = 'block';
            e.target.classList.add('error');
        } else if (e.target.value.trim().length < 2 || e.target.value.trim().length > 30) {
            document.getElementsByClassName('error_first_name')[0].innerHTML = 'First name must be between 2 to 30 character.';
            document.getElementsByClassName('error_first_name')[0].style.display = 'block';
            e.target.classList.add('error');
        } else if (e.target.value.trim().match(regex)) {
            document.getElementsByClassName('error_first_name')[0].innerHTML = 'Please Enter valid First name.';
            document.getElementsByClassName('error_first_name')[0].style.display = 'block';
            e.target.classList.add('error');
        } else if (e.target.value.split(" ").join("") !== e.target.value) {
            document.getElementsByClassName('error_first_name')[0].innerHTML = 'Please Enter valid First name.';
            document.getElementsByClassName('error_first_name')[0].style.display = 'block';
            e.target.classList.add('error');
        } else {
            document.getElementsByClassName('error_first_name')[0].innerHTML = "";
            document.getElementsByClassName('error_first_name')[0].style.display = 'none';
            e.target.classList.remove('error');
        }

        this.setState({ first_name: e.target.value })
    }

    handleLastname = (e) => {
        if (e.target.value.trim().length == 0) {
            document.getElementsByClassName('error_last_name')[0].innerHTML = 'Last Name is required.';
            document.getElementsByClassName('error_last_name')[0].style.display = 'block';
            e.target.classList.add('error');
        } else if (e.target.value.trim().length < 2 || e.target.value.trim().length > 30) {
            document.getElementsByClassName('error_last_name')[0].innerHTML = 'Last name must be between 2 to 30 character.';
            document.getElementsByClassName('error_last_name')[0].style.display = 'block';
            e.target.classList.add('error');
        } else if (e.target.value.trim().match(regex)) {
            document.getElementsByClassName('error_last_name')[0].innerHTML = 'Please Enter valid Last name.';
            document.getElementsByClassName('error_last_name')[0].style.display = 'block';
            e.target.classList.add('error');
        } else if (e.target.value.split(" ").join("") !== e.target.value) {
            document.getElementsByClassName('error_last_name')[0].innerHTML = 'Please Enter valid Last name.';
            document.getElementsByClassName('error_last_name')[0].style.display = 'block';
            e.target.classList.add('error');
        } else {
            document.getElementsByClassName('error_last_name')[0].innerHTML = "";
            document.getElementsByClassName('error_last_name')[0].style.display = 'none';
            e.target.classList.remove('error');
        }
        this.setState({ last_name: e.target.value })
    }

    handleMiddlename = (e) => {
        if (e.target.value.trim().length < 0 || e.target.value.trim().length > 30) {
            document.getElementsByClassName('error_middle_name')[0].innerHTML = 'Middle name must be between 0 to 30 character.';
            document.getElementsByClassName('error_middle_name')[0].style.display = 'block';
            e.target.classList.add('error');
        } else if (e.target.value.trim().match(regex)) {
            document.getElementsByClassName('error_middle_name')[0].innerHTML = 'Please Enter valid Middle name.';
            document.getElementsByClassName('error_middle_name')[0].style.display = 'block';
            e.target.classList.add('error');
        } else if (e.target.value.split(" ").join("") !== e.target.value) {
            document.getElementsByClassName('error_middle_name')[0].innerHTML = 'Please Enter valid Middle name.';
            document.getElementsByClassName('error_middle_name')[0].style.display = 'block';
            e.target.classList.add('error');
        } else {
            document.getElementsByClassName('error_middle_name')[0].innerHTML = "";
            document.getElementsByClassName('error_middle_name')[0].style.display = 'none';
            e.target.classList.remove('error');
        }
        this.setState({ middle_name: e.target.value })
    }

    handleSearch = (e) => {
        this.setState({ search: e.target.value })

        let assessor_data = JSON.stringify({
            text: e.target.value
        })

        fetch(API + 'get_all_accessor.php', {
            method: 'POST',
            body: assessor_data
        }).then((response) => response.json()).then((responseJsonFromServer) => {
            if (responseJsonFromServer.result == "success") {

                this.setState({
                    assessor_data: responseJsonFromServer.search_data
                })

            } else {
                this.setState({
                    assessor_data: [],
                    user_message: responseJsonFromServer.msg
                })
            }
        })

        if (e.target.value.trim().length > 0) {
            this.setState({ showAssessorList: true })
        } else {
            this.setState({ showAssessorList: false })
        }
    }

    selectedAssessor = (item) => {
        let contact_number = item.contact.split(' ');
        let country_code = contact_number[0];
        let mobile_number = contact_number[1];

        this.setState({
            showAssessorList: false,
            assessor_id: item.id,
            first_name: item.first_name,
            last_name: item.last_name,
            middle_name: item.middle_name,
            date_of_birth: moment(item.date_of_birth).toDate(),
            gender: item.gender,
            email: item.email,
            address: item.address,
            post_code: item.post_code,
            region: item.regions,
            added_by: item.added_by,
            contact_number: mobile_number,
            areaCode: country_code,
            search: item.email
        })
    }

    handleDateOfBirth = (e) => {
        if (e == '' || e == null) {
            document.getElementsByClassName('error_date_of_birth')[0].innerHTML = 'Date of birth is required.';
            document.getElementsByClassName('error_date_of_birth')[0].style.display = 'block';
            this.setState({ date_of_birthValidation: false })
        } else {
            document.getElementsByClassName('error_date_of_birth')[0].innerHTML = "";
            document.getElementsByClassName('error_date_of_birth')[0].style.display = 'none';
            this.setState({ date_of_birthValidation: true })
        }
        this.setState({ date_of_birth: e })
    }

    handleGender = (e) => {
        if (e.target.value.trim().length == 0) {
            document.getElementsByClassName('error_gender')[0].innerHTML = 'Gender is required.';
            document.getElementsByClassName('error_gender')[0].style.display = 'block';
            e.target.classList.add('error');
        } else {
            document.getElementsByClassName('error_gender')[0].innerHTML = "";
            document.getElementsByClassName('error_gender')[0].style.display = 'none';
            e.target.classList.remove('error');
        }
        this.setState({ gender: e.target.value })
    }

    handleEmail = (e) => {
        const pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (e.target.value.trim().length == 0) {
            document.getElementsByClassName('error_email')[0].innerHTML = 'Email is required.';
            document.getElementsByClassName('error_email')[0].style.display = 'block';
            e.target.classList.add('error');
        } else if (e.target.value.trim().length < 5 || e.target.value.trim().length > 50) {
            document.getElementsByClassName('error_email')[0].innerHTML = 'Email must be between 5 to 50 character.';
            document.getElementsByClassName('error_email')[0].style.display = 'block';
            e.target.classList.add('error');
        } else if (!e.target.value.trim().match(pattern)) {
            document.getElementsByClassName('error_email')[0].innerHTML = 'Please Enter valid Email ID.';
            document.getElementsByClassName('error_email')[0].style.display = 'block';
            e.target.classList.add('error');
        } else {
            document.getElementsByClassName('error_email')[0].innerHTML = "";
            document.getElementsByClassName('error_email')[0].style.display = 'none';
            e.target.classList.remove('error');
        }
        this.setState({ email: e.target.value })
    }

    handleAddress = (e) => {
        if (e.target.value.trim().length == 0) {
            document.getElementsByClassName('error_address')[0].innerHTML = 'Address is required.';
            document.getElementsByClassName('error_address')[0].style.display = 'block';
            e.target.classList.add('error');
        } else if (e.target.value.trim().length < 4 || e.target.value.trim().length > 150) {
            document.getElementsByClassName('error_address')[0].innerHTML = 'Address must be between 4 to 150 character.';
            document.getElementsByClassName('error_address')[0].style.display = 'block';
            e.target.classList.add('error');
        } else if (e.target.value.trim().match(regex)) {
            document.getElementsByClassName('error_address')[0].innerHTML = 'Please Enter valid Address.';
            document.getElementsByClassName('error_address')[0].style.display = 'block';
            e.target.classList.add('error');
        } else {
            document.getElementsByClassName('error_address')[0].innerHTML = "";
            document.getElementsByClassName('error_address')[0].style.display = 'none';
            e.target.classList.remove('error');
        }
        this.setState({ address: e.target.value })
    }

    handleRegion = (e) => {
        if (e.target.value.trim().length == 0) {
            document.getElementsByClassName('error_region')[0].innerHTML = 'Region is required.';
            document.getElementsByClassName('error_region')[0].style.display = 'block';
            e.target.classList.add('error');
        } else if (e.target.value.trim().match(regex)) {
            document.getElementsByClassName('error_region')[0].innerHTML = 'Please Enter valid Region.';
            document.getElementsByClassName('error_region')[0].style.display = 'block';
            e.target.classList.add('error');
        } else {
            document.getElementsByClassName('error_region')[0].innerHTML = "";
            document.getElementsByClassName('error_region')[0].style.display = 'none';
            e.target.classList.remove('error');
        }
        this.setState({ region: e.target.value })
    }

    handleAddedBy = (e) => {
        if (e.target.value.trim().length == 0) {
            document.getElementsByClassName('error_added_by')[0].innerHTML = 'Changed by is required.';
            document.getElementsByClassName('error_added_by')[0].style.display = 'block';
            e.target.classList.add('error');
        } else if (e.target.value.trim().length < 2 || e.target.value.trim().length > 30) {
            document.getElementsByClassName('error_added_by')[0].innerHTML = 'Changed by must be between 2 to 30 character.';
            document.getElementsByClassName('error_added_by')[0].style.display = 'block';
            e.target.classList.add('error');
        } else if (e.target.value.trim().match(regex)) {
            document.getElementsByClassName('error_added_by')[0].innerHTML = 'Please Enter valid Changed by.';
            document.getElementsByClassName('error_added_by')[0].style.display = 'block';
            e.target.classList.add('error');
        } else {
            document.getElementsByClassName('error_added_by')[0].innerHTML = "";
            document.getElementsByClassName('error_added_by')[0].style.display = 'none';
            e.target.classList.remove('error');
        }
        this.setState({ added_by: e.target.value })
    }

    handlePostCode = (e) => {
        if (e.target.value.trim().length == 0) {
            document.getElementsByClassName('error_post_code')[0].innerHTML = 'Post code is required.';
            document.getElementsByClassName('error_post_code')[0].style.display = 'block';
            e.target.classList.add('error');
        } else if (e.target.value.trim().length < 3 || e.target.value.trim().length > 8) {
            document.getElementsByClassName('error_post_code')[0].innerHTML = 'Post code must be between 3 to 8 character.';
            document.getElementsByClassName('error_post_code')[0].style.display = 'block';
            e.target.classList.add('error');
        } else if (e.target.value.trim().match(regex)) {
            document.getElementsByClassName('error_post_code')[0].innerHTML = 'Please Enter valid Post code.';
            document.getElementsByClassName('error_post_code')[0].style.display = 'block';
            e.target.classList.add('error');
        } else {
            document.getElementsByClassName('error_post_code')[0].innerHTML = "";
            document.getElementsByClassName('error_post_code')[0].style.display = 'none';
            e.target.classList.remove('error');
        }
        this.setState({ post_code: e.target.value })
    }

    handleContactNumber = (e) => {
        let value = parseInt(e.target.value);
        let round_number = Math.round(value);
        if (e.target.value.trim().length == 0) {
            document.getElementsByClassName('error_contact_number')[0].innerHTML = 'Contact number is required.';
            document.getElementsByClassName('error_contact_number')[0].style.display = 'block';
            e.target.classList.add('error');
        } else if (e.target.value.trim().length < 8 || e.target.value.trim().length > 14) {
            document.getElementsByClassName('error_contact_number')[0].innerHTML = 'Contact number must be between 8 to 14 character.';
            document.getElementsByClassName('error_contact_number')[0].style.display = 'block';
            e.target.classList.add('error');
        } else if (round_number === 0 || e.target.value.trim().match(regex)) {
            document.getElementsByClassName('error_contact_number')[0].innerHTML = 'Please Enter valid Contact number.';
            document.getElementsByClassName('error_contact_number')[0].style.display = 'block';
            e.target.classList.add('error');
        } else {
            document.getElementsByClassName('error_contact_number')[0].innerHTML = "";
            document.getElementsByClassName('error_contact_number')[0].style.display = 'none';
            e.target.classList.remove('error');
        }
        this.setState({ contact_number: e.target.value })
    }

    handleSubmit = () => {
        let mobile_number = parseInt(this.state.contact_number);
        let pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        let errorcount = 0;

        if (this.state.first_name.trim().length < 2 || this.state.first_name.trim().length > 30 || this.state.first_name.trim().match(regex) || this.state.first_name.split(" ").join("") !== this.state.first_name) {
            if (this.state.first_name.trim().length == 0) {
                document.getElementsByClassName('error_first_name')[0].innerHTML = 'First Name is required.';
            }
            document.getElementsByClassName('error_first_name')[0].style.display = 'block';
            document.getElementById('first_name').classList.add('error');
            errorcount++;
        } if (this.state.last_name.trim().length < 2 || this.state.last_name.trim().length > 30 || this.state.last_name.trim().match(regex) || this.state.last_name.split(" ").join("") !== this.state.last_name) {
            if (this.state.last_name.trim().length == 0) {
                document.getElementsByClassName('error_last_name')[0].innerHTML = 'Last Name is required.';
            }
            document.getElementsByClassName('error_last_name')[0].style.display = 'block';
            document.getElementById('last_name').classList.add('error');
            errorcount++;
        } if (this.state.middle_name.split(" ").join("") !== this.state.middle_name) {
            document.getElementsByClassName('error_middle_name')[0].style.display = 'block';
            document.getElementById('middle_name').classList.add('error');
            errorcount++;
        } if (this.state.date_of_birth == '' || this.state.date_of_birth == null) {
            document.getElementsByClassName('error_date_of_birth')[0].innerHTML = 'Date of birth is required.';
            document.getElementsByClassName('error_date_of_birth')[0].style.display = 'block';
            document.getElementById('date_of_birth').classList.add('error');
            errorcount++;
        } if (this.state.gender.trim().length == 0) {
            document.getElementsByClassName('error_gender')[0].innerHTML = 'Gender is required.';
            document.getElementsByClassName('error_gender')[0].style.display = 'block';
            document.getElementById('gender').classList.add('error');
            errorcount++;
        } if (this.state.email.trim().length < 5 || this.state.email.trim().length > 50 || this.state.email.trim().match(regex) || !this.state.email.trim().match(pattern)) {
            if (this.state.email.trim().length == 0) {
                document.getElementsByClassName('error_email')[0].innerHTML = 'Email is required.';
            }
            document.getElementsByClassName('error_email')[0].style.display = 'block';
            document.getElementById('email').classList.add('error');
            errorcount++;
        } if (this.state.address.trim().length < 4 || this.state.address.trim().length > 150 || this.state.address.trim().match(regex)) {
            if (this.state.address.trim().length == 0) {
                document.getElementsByClassName('error_address')[0].innerHTML = 'Address is required.';
            }
            document.getElementsByClassName('error_address')[0].style.display = 'block';
            document.getElementById('address').classList.add('error');
            errorcount++;
        } if (this.state.region.trim().length == 0) {
            document.getElementsByClassName('error_region')[0].innerHTML = 'Region is required.';
            document.getElementsByClassName('error_region')[0].style.display = 'block';
            document.getElementById('region').classList.add('error');
            errorcount++;
        } if (this.state.added_by.trim().length < 2 || this.state.added_by.trim().length > 30 || this.state.added_by.trim().match(regex)) {
            if (this.state.added_by.trim().length == 0) {
                document.getElementsByClassName('error_added_by')[0].innerHTML = 'Changed by is required.';
            }
            document.getElementsByClassName('error_added_by')[0].style.display = 'block';
            document.getElementById('added_by').classList.add('error');
            errorcount++;
        } if (this.state.post_code.trim().length < 3 || this.state.post_code.trim().length > 8 || this.state.post_code.trim().match(regex)) {
            if (this.state.post_code.trim().length == 0) {
                document.getElementsByClassName('error_post_code')[0].innerHTML = 'Changed by is required.';
            }
            document.getElementsByClassName('error_post_code')[0].style.display = 'block';
            document.getElementById('post_code').classList.add('error');
            errorcount++;
        } if (this.state.contact_number.trim().length < 8 || this.state.contact_number.trim().length > 14 || Math.round(mobile_number) === 0 || this.state.contact_number.trim().match(regex)) {
            if (this.state.contact_number.trim().length == 0) {
                document.getElementsByClassName('error_contact_number')[0].innerHTML = 'Contact number is required.';
            }
            document.getElementsByClassName('error_contact_number')[0].style.display = 'block';
            document.getElementById('contact_number').classList.add('error');
            errorcount++;
        }
        if (errorcount == 0) {

            let assessor_details = JSON.stringify({
                accessor_id: this.state.assessor_id,
                username: this.state.first_name,
                last_name: this.state.last_name,
                middle_name: this.state.middle_name,
                dob: this.state.date_of_birth.toLocaleDateString("en-US"),
                gender: this.state.gender,
                email: this.state.email,
                address: this.state.address,
                regions: this.state.region,
                added_by: this.state.added_by,
                post_code: this.state.post_code,
                number: this.state.areaCode + ' ' + this.state.contact_number
            })
            this.setState({ data_saveLoader: true }, () =>
                fetch(API + 'edit_accessor.php', {
                    method: 'POST',
                    body: assessor_details
                }).then((response) => response.json()).then((responseJsonFromServer) => {
                    var x = document.getElementById("snackbar");
                    x.className = "show";
                    setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);
                    this.setState({ data_saveLoader: false })
                    if (responseJsonFromServer.result == "success") {
                        x.innerHTML = responseJsonFromServer.msg;
                        setTimeout(() => {
                            this.props.history.push('/all_assessor')
                        }, 3000);
                    } else {
                        x.innerHTML = responseJsonFromServer.msg;
                    }

                }).catch((error) => {
                    if (error.message == 'Failed to fetch') {
                        this.setState({ networkError: true })
                    }
                }))

        }
    }

    handleDeleteAssessorPopupOpen = () => {
        this.setState({ delete_assessor: true })
    }

    handleDeleteAssessorPopupClose = () => {
        this.setState({ delete_assessor: false })
    }

    handleDeleteAssessor = () => {
        let assessor_data = JSON.stringify({
            accessor_id: this.state.assessor_id
        })

        this.setState({ delete_assessor: false })

        fetch(API + 'delete_accessor.php', {
            method: 'POST',
            body: assessor_data
        }).then((response) => response.json()).then((responseJsonFromServer) => {
            var x = document.getElementById("snackbar");
            x.className = "show";
            setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);

            if (responseJsonFromServer.result == "success") {

                x.innerHTML = responseJsonFromServer.msg;
                setTimeout(() => {
                    this.props.history.push('/all_assessor')
                }, 3000);
            } else {
                x.innerHTML = responseJsonFromServer.msg;
            }
        })
    }

    handleClearSearch = () => {
        this.setState({ search: '', showAssessorList: false })
    }

    render() {
        if (this.state.networkError) {
            return <NoInternet />
        } else {
            if (this.state.isLoader) {
                return (
                    <div style={{ minHeight: '100vh', backgroundColor: '#EEF2F6' }}>
                        <Router />
                        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 80 }}>
                            <img src={require('../../assets/Loader.gif')} style={{ width: 100, height: 100 }} />
                        </div>
                    </div>
                )
            } else {
                const { areaCode, phone, validate } = this.state;
                const currentItem = find(FLAG_SELECTOR_OPTION_LIST, { id: areaCode })[0];
                return (
                    <div>
                        <Router />
                        <div style={{ backgroundColor: '#EEF2F6', minHeight: '100vh', overflow: 'hidden' }}>
                            <div className="block-v-md" style={{ backgroundColor: '#ffff', paddingLeft: 20, paddingTop: 80, paddingRight: 20, paddingBottom: 20 }}>
                                <div>
                                    <div className="row" style={{ marginTop: -10, marginBottom: -10 }}>
                                        <Accordion style={{ width: '100%' }} defaultActiveKey="0">
                                            <div className="row">
                                                <div className="col-md-4 col-sm-4">
                                                    {/* <label style={{ fontSize: 25, paddingLeft: 30, fontWeight: '600' }}>Dashboard</label> */}
                                                </div>
                                                <div className="col-md-4 col-sm-4 text-center" >
                                                    <Accordion.Toggle as={Button} style={{ backgroundColor: '#ebeced' }} variant="default" eventKey="0">
                                                        <span style={{ fontWeight: '700' }}>Edit Assessor</span> or Filter by <span style={{ fontWeight: '700' }}>Assessor</span>
                                                    </Accordion.Toggle>
                                                </div>
                                            </div>

                                            <div eventKey="0">
                                                <div className="pt-4" >
                                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                                                        <div className="col-lg-9 col-md-9 col-sm-12 p-0">
                                                            <div className="row">
                                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                                    {/* <div className="row">
                                                                <div className="col-lg-12">
                                                                    <h6>Edit new assessor</h6>
                                                                </div>
                                                                <div className="col-lg-6 col-md-6 col-sm-12" style={styles.inputDiv}>
                                                                    <input type="text" id="first_name" minLength={2} maxLength={30} placeholder="First Name*" value={this.state.first_name} className="form-control" onChange={this.handleFirstname} onKeyDown={this.press} />
                                                                    <label className="input-error error_first_name text-left"></label>
                                                                </div>
                                                                <div className="col-lg-6 col-md-6 col-sm-12" style={styles.inputDiv}>
                                                                    <input type="text" id="last_name" minLength={2} maxLength={30} placeholder="Last Name*" value={this.state.last_name} className="form-control" onChange={this.handleLastname} onKeyDown={this.press} />
                                                                    <label className="input-error error_last_name text-left"></label>
                                                                </div>
                                                                <div className="col-lg-6 col-md-6 col-sm-12" style={styles.inputDiv}>
                                                                    <input type="text" id="middle_name" minLength={2} maxLength={30} placeholder="Middle Name*" value={this.state.middle_name} className="form-control" onChange={this.handleMiddlename} onKeyDown={this.press} />
                                                                    <label className="input-error error_middle_name text-left"></label>
                                                                </div>
                                                            </div> */}
                                                                </div>
                                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                                    <h6>Search</h6>
                                                                    <div className="col-12 row p-0 m-0">
                                                                        <div className="col-11 p-0" style={styles.inputDiv}>
                                                                            <input type="text" placeholder="Search by name, email and contact number" autoComplete="off" autoCorrect="off" value={this.state.search} onChange={this.handleSearch} style={styles.inputField} className="form-control" />
                                                                            <div style={{ display: this.state.showAssessorList ? '' : 'none' }}>
                                                                                {this.state.assessor_data.length == 0 ? <div style={{ color: 'rgb(123, 123, 123)', padding: '0.5rem' }}>
                                                                                    <em>{this.state.user_message}</em>
                                                                                </div> : <ul style={styles.inputAssessor_name}>
                                                                                        {this.state.assessor_data.map((item, index) =>
                                                                                            <li
                                                                                                style={index == this.state.activeAssessor ? styles.activeinputAssessor_name : styles.inputAssessor_nameList}
                                                                                                onClick={() => this.selectedAssessor(item)}
                                                                                                id={item.accessor_id}
                                                                                            >
                                                                                                {item.first_name + ' ' + item.middle_name + ' ' + item.last_name} <br />
                                                                                                {item.email} <br />
                                                                                                {item.contact}
                                                                                            </li>
                                                                                        )}
                                                                                    </ul>}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-1 p-0 text-center" style={{ border: '1px solid rgb(206, 212, 218)', borderRadius: 3, cursor: 'pointer', height: 40 }} onClick={this.handleClearSearch}>
                                                                            <Icon icon={cross} size="20" style={styles.clearFilterIcon} />
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Accordion>
                                    </div>
                                </div>
                            </div>
                            <div className="body-container" style={{ paddingTop: 40, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                                <div className="col-lg-9 col-md-9 col-sm-12 p-0 user-form-container">
                                    <div className="row">
                                        <div className="col-12 p-0">
                                            <div className="col-lg-6 col-md-6 col-sm-12">
                                                <div className="row">
                                                    <div className="col-lg-6 col-md-6 col-sm-12" style={styles.inputDiv}>
                                                        <input type="text" id="first_name" autoComplete="off" autoCorrect="off" minLength={2} maxLength={30} placeholder="First name*" value={this.state.first_name} className="form-control" onChange={this.handleFirstname} onKeyDown={this.press} />
                                                        <label className="input-error error_first_name text-left"></label>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-12" style={styles.inputDiv}>
                                                        <input type="text" id="last_name" autoComplete="off" autoCorrect="off" minLength={2} maxLength={30} placeholder="Last name*" value={this.state.last_name} className="form-control" onChange={this.handleLastname} onKeyDown={this.press} />
                                                        <label className="input-error error_last_name text-left"></label>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-12" style={styles.inputDiv}>
                                                        <input type="text" id="middle_name" autoComplete="off" autoCorrect="off" minLength={2} maxLength={30} placeholder="Middle name" value={this.state.middle_name} className="form-control" onChange={this.handleMiddlename} onKeyDown={this.press} />
                                                        <label className="input-error error_middle_name text-left"></label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3" style={styles.inputDiv}>
                                            <DatePicker
                                                className={!this.state.date_of_birthValidation ? "error form-control" : "form-control"}
                                                placeholderText="Date of birth*"
                                                maxDate={new Date()}
                                                minDate={new Date(1899, 12, 1)}
                                                showTimeSelect={false}
                                                dateFormat="dd/MM/yyyy"
                                                locale={false}
                                                autoComplete="off"
                                                autoCorrect="off"
                                                showTimeInput={false}
                                                selected={this.state.date_of_birth}
                                                onChange={this.handleDateOfBirth}
                                                id="date_of_birth"
                                            />
                                            <label className="input-error error_date_of_birth text-left"></label>
                                        </div>
                                        <div className="col-lg-3" style={styles.inputDiv}>
                                            <select value={this.state.gender} className="form-control" id="gender" placeholderText="gender" value={this.state.gender} onChange={this.handleGender}>
                                                <option value="" disabled selected hidden> Gender*</option>
                                                <option value="male"> Male</option>
                                                <option value="female">Female</option>
                                            </select>
                                            <label className="input-error error_gender text-left"></label>
                                        </div>
                                        <div className="col-lg-6" style={styles.inputDiv}>
                                            <input type="text" id="email" placeholder="Email address*" style={{ cursor: 'no-drop' }} disabled value={this.state.email} className="form-control" onChange={this.handleEmail} />
                                            <label className="input-error error_email text-left"></label>
                                        </div>
                                        <div className="col-lg-6" style={styles.inputDiv}>
                                            <input type="text" placeholder="Address*" autoComplete="off" autoCorrect="off" id="address" minLength={4} maxLength={150} value={this.state.address} className="form-control inputbox" onChange={this.handleAddress} />
                                            <label className="input-error error_address text-left"></label>
                                        </div>
                                        <div className="col-lg-3" style={styles.inputDiv}>
                                            {/* <input type="text" placeholder="Region" id="region" value={this.state.region} className="form-control inputbox" onChange={this.handleRegion} /> */}
                                            <select className="form-control inputbox" id="region" value={this.state.region} onChange={this.handleRegion} >
                                                <option value='' disabled selected hidden>Select region*</option>
                                                {this.state.region_data.map(item =>
                                                    <option value={item.region_id}>{item.regions}</option>
                                                )}
                                            </select>
                                            <label className="input-error error_region text-left"></label>
                                        </div>
                                        <div className="col-lg-3" style={styles.inputDiv}>
                                            <h6>Changed by</h6>
                                            <input type="text" placeholder="Changed by*" autoComplete="off" autoCorrect="off" id="added_by" minLength={2} maxLength={30} value={this.state.added_by} className="form-control" onChange={this.handleAddedBy} />
                                            <label className="input-error error_added_by text-left"></label>
                                        </div>
                                        <div className="col-lg-6" style={styles.inputDiv}>
                                            <div className="row" style={{ paddingRight: 15, paddingLeft: 15 }}>
                                                <div className="country-code">
                                                    <ReactCustomFlagSelect
                                                        tabIndex={"1"}
                                                        id={"areaCode"}
                                                        name={"areaCode"}
                                                        value={currentItem.id}
                                                        disabled={false}
                                                        showSearch={true}
                                                        showArrow={true}
                                                        animate={true}
                                                        optionList={FLAG_SELECTOR_OPTION_LIST}
                                                        customStyleContainer={{ border: "none", fontSize: "12px" }}
                                                        customStyleSelect={{ width: "100%" }}
                                                        customStyleOptionListItem={{}}
                                                        customStyleOptionListContainer={{
                                                            maxHeight: "150px",
                                                            overflow: "auto",
                                                            width: "120px"
                                                        }}
                                                        onChange={areaCode => {
                                                            this.setState({ areaCode: areaCode });
                                                        }}
                                                    />
                                                </div>
                                                <div className="contact-number">
                                                    <input type="text" minLength="8" maxLength="14" autoComplete="off" autoCorrect="off" placeholder="Contact number*" id="contact_number" value={this.state.contact_number} className="form-control" onChange={this.handleContactNumber} onKeyDown={this.number_press} />
                                                </div>
                                            </div>


                                            <label className="input-error error_contact_number text-left" ></label>
                                        </div>
                                        <div className="col-lg-3" style={styles.inputDiv}>
                                            <input type="text" placeholder="Post code*" autoComplete="off" autoCorrect="off" id="post_code" minLength={3} maxLength={8} value={this.state.post_code} className="form-control" onChange={this.handlePostCode} />
                                            <label className="input-error error_post_code text-left"></label>
                                        </div>
                                    </div>
                                    <div className="row" style={{ paddingTop: 50, paddingBottom: 50 }}>
                                        <div className="col-lg-3">
                                            <Button variant="primary" disabled={this.state.data_saveLoader} onClick={this.handleSubmit} block>Save</Button>
                                        </div>
                                        <div className="col-lg-6"></div>
                                        <div className="col-lg-3 delete_button">
                                            {/* <Button variant="danger" onClick={this.handleDeleteAssessor} block>Delete</Button> */}
                                            <Button variant="danger" onClick={this.handleDeleteAssessorPopupOpen} block>Delete</Button>
                                        </div>
                                        <Modal show={this.state.delete_assessor} onHide={this.handleDeleteAssessorPopupClose}>
                                            <Modal.Body>
                                                Are you sure you want to delete this assessor?
                                        </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="secondary" onClick={this.handleDeleteAssessorPopupClose}>No</Button>
                                                <Button style={styles.confirmButton} onClick={this.handleDeleteAssessor}>Yes</Button>
                                            </Modal.Footer>
                                            {/* <Button variant="primary" className="mt-3" onClick={this.handleDeleteAssessor} block>Change assessor</Button> */}
                                        </Modal>
                                        <div id="snackbar"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        }
    }
}